export async function readJsonResponse<T extends { error?: string }>(
  response: Response
): Promise<T> {
  const text = await response.text();
  if (!text) {
    return {} as T;
  }

  try {
    return JSON.parse(text) as T;
  } catch {
    return {
      error: response.ok
        ? "Server returned an invalid response."
        : `Request failed (${response.status}).`,
    } as T;
  }
}
